import { GlobalStyles } from "@mui/material";

// App-wide surfaces for the grey (#f6f8fb) content canvas: anything that holds data or input is
// white, so it reads as a surface on the canvas rather than blending into it.
// "body" in the selectors outranks App.css, which some older screens load with heavier table borders.
export const AppSurfaceStyles = () => (
  <GlobalStyles
    styles={{
      // Every table sits on white with a hairline border and rounded corners.
      "body .MuiTableContainer-root": {
        backgroundColor: "#ffffff",
      },
      "body .MuiTableContainer-root:not(.MuiPaper-root), body .mui-table-container-style": {
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      },
      // Lighter cell lines for the older bordered tables.
      "body .mui-table-bordered td, body .mui-table-bordered th": {
        borderColor: "#e5e7eb",
      },
      // Input boxes are white too, so filters in page headers don't show the grey through them.
      "body .MuiOutlinedInput-root": {
        backgroundColor: "#ffffff",
      },
    }}
  />
);
